// src/components/ProtectedRoute.tsx
import React from "react";
import {Navigate, Outlet} from "react-router-dom";
import useAuthStore from "../store/useAuthStore.ts";
import Logo from "../components/Logo.tsx";
import LogoLoader from "../components/LogoLoader.tsx";
import AuthenticatedLayout from "../components/Layouts/AuthenticatedLayout.tsx";
import NoneAuthenticatedLayout from "../components/Layouts/NoneAuthenticatedLayout.tsx";

const ProtectedRoute: React.FC = () => {
  const {isAuthenticated, loading} = useAuthStore();

  // If the auth state is still loading, show a spinner
  if (loading) {
    return (
      <div className="none-authenticated-layout-wrapper">
        <Logo/>
        <LogoLoader/>
      </div>
    )
  }

  // If the user is not authenticated after loading is complete, redirect to the login page
  if (!isAuthenticated) {
    console.log("User is not authenticated, redirecting to /login");
    return <Navigate to="/login" replace/>;
  }

  // If authenticated, render the protected route
  return <AuthenticatedLayout/>
};

export default ProtectedRoute;
